import { render, staticRenderFns } from "./TransactionsMenu.vue?vue&type=template&id=4378057b&scoped=true&"
import script from "./TransactionsMenu.vue?vue&type=script&lang=js&"
export * from "./TransactionsMenu.vue?vue&type=script&lang=js&"
import style0 from "./TransactionsMenu.vue?vue&type=style&index=0&id=4378057b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4378057b",
  null
  
)

export default component.exports